import useProjectTypesState from 'screens/Admin/ProjectTypes/hooks/useProjectTypesState'
import { IProjectType } from 'screens/Admin/ProjectTypes/projectTypes.types'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  value: string | null
  name: string
  onChange: (val: string, name: string) => void
}

const ProjectTypeSelect = (props: IProps) => {
  const { projectTypesMap, projectTypesState } = useProjectTypesState()

  const handleSelect = (val: IProjectType | null) => {
    props.onChange(val?.id ?? null, props.name)
  }

  const selected = projectTypesMap[props.value]

  return (
    <Dropdown
      options={projectTypesState.items}
      selectedOption={selected}
      title='Тип проекта'
      onSelect={handleSelect}
      getOptionKey={(o) => o?.id}
      getOptionLabel={(o) => o?.name}
      allowEmpty={false}
    />
  )
}

export default ProjectTypeSelect
